import StudioCanvas from "./StudioCanvas";
export default StudioCanvas;